// @ts-nocheck
export const localeCodes =  [
  "en-US",
  "fr-FR",
  "fr-CA",
  "es-ES",
  "pt-PT",
  "de-DE",
  "ja-JP",
  "da-DK",
  "fi-FI",
  "no-NO",
  "sv-SE",
  "nl-NL",
  "eu-PT",
  "it-IT"
]
export const localeLoaders = {
  "en-US": [
    {
      key: "locale_en_46json_7b4667e1",
      load: () => import("#nuxt-i18n/7b4667e1" /* webpackChunkName: "locale_en_46json_7b4667e1" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_46json_393165c7",
      load: () => import("#nuxt-i18n/393165c7" /* webpackChunkName: "locale_fr_46json_393165c7" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_a582bab8",
      load: () => import("#nuxt-i18n/a582bab8" /* webpackChunkName: "locale_fr_45CA_46json_a582bab8" */),
      cache: true
    }
  ],
  "es-ES": [
    {
      key: "locale_es_46json_5c0a1b26",
      load: () => import("#nuxt-i18n/5c0a1b26" /* webpackChunkName: "locale_es_46json_5c0a1b26" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_46json_db9065eb",
      load: () => import("#nuxt-i18n/db9065eb" /* webpackChunkName: "locale_pt_46json_db9065eb" */),
      cache: true
    }
  ],
  "de-DE": [
    {
      key: "locale_de_46json_ee70439b",
      load: () => import("#nuxt-i18n/ee70439b" /* webpackChunkName: "locale_de_46json_ee70439b" */),
      cache: true
    }
  ],
  "ja-JP": [
    {
      key: "locale_ja_45JP_46json_838bf89e",
      load: () => import("#nuxt-i18n/838bf89e" /* webpackChunkName: "locale_ja_45JP_46json_838bf89e" */),
      cache: true
    }
  ],
  "da-DK": [
    {
      key: "locale_da_46json_ffb49607",
      load: () => import("#nuxt-i18n/ffb49607" /* webpackChunkName: "locale_da_46json_ffb49607" */),
      cache: true
    }
  ],
  "fi-FI": [
    {
      key: "locale_fi_46json_4d66711c",
      load: () => import("#nuxt-i18n/4d66711c" /* webpackChunkName: "locale_fi_46json_4d66711c" */),
      cache: true
    }
  ],
  "no-NO": [
    {
      key: "locale_no_46json_748d84cf",
      load: () => import("#nuxt-i18n/748d84cf" /* webpackChunkName: "locale_no_46json_748d84cf" */),
      cache: true
    }
  ],
  "sv-SE": [
    {
      key: "locale_sv_46json_7f25191a",
      load: () => import("#nuxt-i18n/7f25191a" /* webpackChunkName: "locale_sv_46json_7f25191a" */),
      cache: true
    }
  ],
  "nl-NL": [
    {
      key: "locale_nl_46json_19ce622f",
      load: () => import("#nuxt-i18n/19ce622f" /* webpackChunkName: "locale_nl_46json_19ce622f" */),
      cache: true
    }
  ],
  "eu-PT": [
    {
      key: "locale_eu_45PT_46json_6aced1ed",
      load: () => import("#nuxt-i18n/6aced1ed" /* webpackChunkName: "locale_eu_45PT_46json_6aced1ed" */),
      cache: true
    }
  ],
  "it-IT": [
    {
      key: "locale_it_46json_c18e326a",
      load: () => import("#nuxt-i18n/c18e326a" /* webpackChunkName: "locale_it_46json_c18e326a" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en-US",
    language: "en-US",
    name: "English"
  },
  {
    code: "fr-FR",
    language: "fr-FR",
    name: "Français"
  },
  {
    code: "fr-CA",
    language: "fr-CA",
    name: "Français (Canada)"
  },
  {
    code: "es-ES",
    language: "es-ES",
    name: "Español"
  },
  {
    code: "pt-PT",
    language: "pt-PT",
    name: "Português"
  },
  {
    code: "de-DE",
    language: "de-DE",
    name: "Deutsch"
  },
  {
    code: "ja-JP",
    language: "ja-JP",
    name: "日本語"
  },
  {
    code: "da-DK",
    language: "da-DK",
    name: "Dansk"
  },
  {
    code: "fi-FI",
    language: "fi-FI",
    name: "Suomi"
  },
  {
    code: "no-NO",
    language: "no-NO",
    name: "Norsk"
  },
  {
    code: "sv-SE",
    language: "sv-SE",
    name: "Svenska"
  },
  {
    code: "nl-NL",
    language: "nl-NL",
    name: "Nederlands"
  },
  {
    code: "eu-PT",
    language: "eu-PT",
    name: "Português (Europeu)"
  },
  {
    code: "it-IT",
    language: "it-IT",
    name: "Italiano"
  }
]
/** client **/

/** client-end **/